import routerOptions0 from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}